import styled from "styled-components";
import { row } from "@ui/components/layout";

export const MenuRow = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "padding",
})<{ onClick?: () => void; padding?: number }>`
	${({ onClick }) => !!onClick && "cursor: pointer"};
	${row(10, "flex-start", "center")};
	${({ theme }) => theme.textStyles.text};
	svg {
		width: 18px;
	}
	span {
		white-space: nowrap;
		${({ padding }) => (padding ? "padding-left: " + padding + "px;" : undefined)}
	}
	${({ padding }) => (padding ? "padding: " + padding + "px;" : undefined)}
`;
